<button (click)="close()" class="close" mat-button title="Cancel"><i class="material-icons clear">clear</i></button>
<div mat-dialog-title>Model Market Center<br>Paid Model Agreement</div>
<mat-dialog-content>
  @if (!nogrid) {
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'140px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  }
  <div [style.maxHeight]="agreementHt" style="overflow-y: auto; border: 1px solid #767676;padding: 8px;"
  [innerHTML]="agreementTxt"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="block">
    <p-checkbox name="single" binary="true" [disabled]="true" [ngModel]="true"></p-checkbox>
    IN WITNESS WHEREOF, Advisor by its duly authorized representative hereby acknowledges and agrees to the
    forgoing Paid Model Agreement.
  </div>
  <button id="closeButton" (click)="close()" class="btn-medium-primary green">Close</button>
</mat-dialog-actions>
